import { makeStyles } from "tss-react/mui";

import { useTheme } from "@mui/material";

const useStyles = makeStyles()({
    wrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    fileUpload: {
        fontSize: "40px",
    },
});
interface Props {
    color?: string;
}
const ArrowFileUp = ({ color }: Props) => {
    const { classes } = useStyles();
    const theme = useTheme();

    return (
        <div className={classes.wrapper}>
            <div className={classes.fileUpload}>
                <i className="fa-solid fa-file-arrow-up" style={{ color: color || theme.palette.emteria.text.primary }}></i>
            </div>
        </div>
    );
};

export default ArrowFileUp;
